@if (data$ | async; as data) {
  <app-category-navigation-ui [node]="node$ | async" [ngClass]="data.styleClass ?? ''"
    [wrapAfter]="+(data.wrapAfter ?? '')" [resetMenuOnClose]="data.resetMenuOnClose"
  [navAriaLabel]="'navigation.categoryNavLabel' | cxTranslate"></app-category-navigation-ui>
}